// extracted by mini-css-extract-plugin
export var deviceTooltipTrigger = "DiscountSwitch-module--deviceTooltipTrigger--a4d2f";
export var rowReverse = "DiscountSwitch-module--rowReverse--61d14";
export var switchRoot = "DiscountSwitch-module--switchRoot--08223";
export var switchThumb = "DiscountSwitch-module--switchThumb--e55eb";
export var switchWrapper = "DiscountSwitch-module--switchWrapper--480ac";